/** @format */

import Commerce from "@chec/commerce.js";

export const commerce = new Commerce(
  "pk_test_24034b34cd05608efa6a1aa2afccdbe12ad40bfdab810",
  true
);
